export const it = {
  nav: {
    home: 'Home',
    services: 'Servizi',
    about: 'Chi Siamo',
    portfolio: 'Portfolio',
    contact: 'Contatti',
    getStarted: 'Inizia',
  },

  hero: {
    tagline: 'AGENZIA CREATIVA',
    title: 'Innovazione Incontra',
    titleHighlight: 'Ispirazione',
    subtitle: 'Creiamo esperienze di marketing audaci e indimenticabili che elevano il tuo brand.',
    cta: 'Inizia il Tuo Progetto',
    watchVideo: 'Guarda Video',
    servicesButton: 'esplorare i servizi',
    scrollText: 'Scorri per esplorare',
  },

  services: {
    tag: 'COSA FACCIAMO',
    title: 'I Nostri',
    titleHighlight: 'Servizi',
    subtitle: 'Soluzioni creative complete per elevare il tuo brand.',
    
    items: [
      {
        icon: '🎨',
        title: 'Branding',
        description: 'Creiamo un\'identità di marca memorabile.',
      },
      {
        icon: '📢',
        title: 'Pubblicità',
        description: 'Campagne strategiche che catturano l\'attenzione.',
      },
      {
        icon: '✏️',
        title: 'Design',
        description: 'Design visivi straordinari che comunicano il tuo brand.',
      },
      {
        icon: '🌐',
        title: 'Marketing Digitale',
        description: 'Strategie basate sui dati per massimizzare la tua presenza online.',
      },
      {
        icon: '🎬',
        title: 'Produzione Video',
        description: 'Produzione video professionale che dà vita al tuo brand.',
      },
      {
        icon: '💻',
        title: 'Sviluppo Siti Web',
        description: 'Siti web personalizzati e responsive.',
      },
      {icon: '📱',
        title: 'App Mobili',
        description: 'Applicazioni mobili intuitive per iOS e Android.',
      },
    ],
  },

  about: {
    tag: 'CHI SIAMO',
    title: 'Perché Scegliere',
    titleHighlight: 'Orvin',
    subtitle: 'Siamo un team di creativi appassionati dedicati alla trasformazione dei brand.',
    
    stats: [
      { number: 78, label: 'Progetti Completati', suffix: '+' },
      { number: 98, label: 'Soddisfazione Clienti', suffix: '%' },
      { number: 4, label: 'Membri del Team', suffix: '+' },
      { number: 5, label: 'Anni di Esperienza', suffix: '' },
    ],

    features: [
      {
        title: 'Eccellenza Creativa',
        description: 'Team creativo pluripremiato.',
      },
      {
        title: 'Approccio Strategico',
        description: 'Strategie basate sui dati.',
      },
      {
        title: 'Focalizzato sul Cliente',
        description: 'Il tuo successo è la nostra priorità.',
      },
    ],
  },

  portfolio: {
    tag: 'IL NOSTRO LAVORO',
    title: 'Progetti',
    titleHighlight: 'In Evidenza',
    subtitle: 'Esplora il nostro portfolio di progetti di successo.',
    close:'chiudere ',
    categories: {
      all: 'Tutti i Progetti',
      branding: 'Branding',
      webDesign: 'Web Design',
      marketing: 'Marketing',
      appDesign: 'Design App',
      video: 'Video',
      design: 'Design',
    },

    viewProject: 'Vedi Progetto',
    featured: 'In Evidenza',
    client: 'Cliente',
    year: 'Anno',
    viewLive: 'Vedi Progetto Live',
  },

  contact: {
    tag: 'CONTATTACI',
    title: 'Creiamo Qualcosa di',
    titleHighlight: 'Straordinario',
    subtitle: 'Pronto a portare il tuo brand al livello successivo?',
    
    form: {
      namePlaceholder: 'Il Tuo Nome *',
      emailPlaceholder: 'La Tua Email *',
      subjectPlaceholder: 'Oggetto (Opzionale)',
      messagePlaceholder: 'Parlaci del tuo progetto... *',
      sendButton: 'Invia Messaggio 🚀',
      sending: 'Invio...',
      requiredNote: '* Campi obbligatori | Risponderemo entro 24 ore',
    },

    info: {
      email: 'Email',
      phone: 'Telefono',
      location: 'Posizione',
    },

    success: {
      title: 'Messaggio Inviato con Successo! 🎉',
      message: 'Abbiamo ricevuto il tuo messaggio. Ti ricontatteremo entro 24 ore!',
    },

    errors: {
      nameRequired: 'Il nome deve contenere almeno 2 caratteri',
      emailInvalid: 'Inserisci un indirizzo email valido',
      messageRequired: 'Il messaggio deve contenere almeno 10 caratteri',
      subjectTooLong: 'L\'oggetto deve essere inferiore a 100 caratteri',
      fixErrors: 'Correggi gli errori nel modulo',
      sendFailed: 'Qualcosa è andato storto. Riprova.',
    },
  },

  footer: {
    tagline: 'L\'innovazione incontra l\'ispirazione',
    about: 'Siamo un\'agenzia creativa dedicata a creare esperienze di marketing indimenticabili.',
    quickLinks: 'Link Rapidi',
    services: 'Servizi',
    followUs: 'Seguici',
    copyright: '© 2026 Orvin Creative Agency. Tutti i diritti riservati.',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Termini di Servizio',
    craftedWith: 'Realizzato con passione',
  },
};

